const brands = 
[
        {
            "id": 1,
            "alt": "mercadolibre",
            "titulo": "Mercado Libre"
        },{
            "id": 2,
            "alt": "duki",
            "titulo": "Duki"
        },{
            "id": 3,
            "alt": "legionextranjera",
            "titulo": "Legion Extranjera"
        },{
            "id": 4,
            "alt": "ypf",
            "titulo": "YPF"
        },{
            "id": 21,
            "alt": "mercadoshops",
            "titulo": "Mercado Shops"
        },{
            "id": 5,
            "alt": "mondelez",
            "titulo": "Mondelez"
        },{
            "id": 6,
            "alt": "nickinicole",
            "titulo": "Nicki Nicole"
        },{
            "id": 7,
            "alt": "hidrolit",
            "titulo": "Hidrolit"
        },{
            "id": 8,
            "alt": "peabody",
            "titulo": "Peabody"
        },{
            "id": 9,
            "alt": "pastalinda",
            "titulo": "Pastalinda"
        },{
            "id": 10,
            "alt": "daleplay",
            "titulo": "DalePlay"
        },{
            "id": 10,
            "alt": "cencosud",
            "titulo": "Cencosud"
        },{
            "id": 11,
            "alt": "chevrolet",
            "titulo": "Chevrolet"
        },{
            "id": 12,
            "alt": "longvie",
            "titulo": "Longvie"
        },{
            "id": 13,
            "alt": "norauto",
            "titulo": "Norauto"
        },{
            "id": 14,
            "alt": "infinit",
            "titulo": "Infinit"
        },{
            "id": 15,
            "alt": "lego",
            "titulo": "Lego"
        },{
            "id": 16,
            "alt": "herschel",
            "titulo": "Herschel"
        },{
            "id": 17,
            "alt": "garbarino",
            "titulo": "Garbarino"
        },{
            "id": 18,
            "alt": "dia",
            "titulo": "Dia%"
        },{
            "id": 19,
            "alt": "cher",
            "titulo": "Cher"
        },{
            "id": 20,
            "alt": "creciendo",
            "titulo": "Creciendo"
        },{
            "id": 22,
            "alt": "hbo",
            "titulo": "HBO"
        },{
            "id": 23,
            "alt": "chimmychurry",
            "titulo": "Chimmy Churry"
        },{
            "id": 24,
            "alt": "hudson",
            "titulo": "Hudson"
        },{
            "id": 25,
            "alt": "regina",
            "titulo": "Regina"
        },{
            "id": 26,
            "alt": "tecnocompro",
            "titulo": "Tecno Compro"
        }
]
export default brands